import { render } from "./StockModul.vue?vue&type=template&id=0e8e29e4"
import script from "./StockModul.vue?vue&type=script&lang=js"
export * from "./StockModul.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__